<template>
    <BModal v-model="isModalActive" centered hide-footer>
        <slot />
    </BModal>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
    setup() {
        const isModalActive = ref(false)

        const open = function() {
            isModalActive.value = true
        }

        const close = function() {
            isModalActive.value = false
        }

        const toggle = function() {
            isModalActive.value = !isModalActive.value
        }

        return {
            isModalActive,
            open,
            close,
            toggle
        }
    }
}
</script>